import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";

interface ProfileDropdownProps {
  isOpen: boolean;
  onClose: () => void;
  onLogout?: () => void;
}

export const ProfileDropdown: React.FC<ProfileDropdownProps> = ({
  isOpen,
  onClose,
  onLogout,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const storedUser = localStorage.getItem("user") || localStorage.getItem("email");
  const userName = storedUser ? storedUser.split("@")[0] : "Alex Vance";
  const userEmail = storedUser || "alex@indexx.ai";

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        onClose();
      }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      className="homepage1-profile-dropdown"
      id="profile-dropdown"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="homepage1-profile-header">
        <div className="homepage1-profile-header-top">
          <span className="homepage1-profile-name">{userName}</span>
          <span className="homepage1-profile-status">
            <span className="homepage1-profile-status-dot" />
            Active
          </span>
        </div>
        <span className="homepage1-profile-email">{userEmail}</span>
      </div>

      <div className="homepage1-profile-menu">
        <Link
          to="/indexx-exchange/account"
          className="homepage1-profile-link"
          onClick={onClose}
        >
          <span className="material-symbols-outlined">person</span>
          <span>Profile Settings</span>
        </Link>
        <Link
          to="/indexx-exchange/change-password"
          className="homepage1-profile-link"
          onClick={onClose}
        >
          <span className="material-symbols-outlined">shield</span>
          <span>Account & Security</span>
        </Link>
        <Link
          to="/indexx-exchange/buy-sell/wallet"
          className="homepage1-profile-link"
          onClick={onClose}
        >
          <span className="material-symbols-outlined">account_balance_wallet</span>
          <span>Connected Wallet</span>
        </Link>
        <Link
          to="/indexx-exchange/how-it-works"
          className="homepage1-profile-link"
          onClick={onClose}
        >
          <span className="material-symbols-outlined">tune</span>
          <span>Preferences</span>
        </Link>
      </div>

      <div className="homepage1-profile-footer">
        <button
          type="button"
          className="homepage1-profile-logout"
          onClick={() => {
            onClose();
            if (onLogout) {
              onLogout();
            } else {
              localStorage.clear();
              window.location.reload();
            }
          }}
        >
          <span className="material-symbols-outlined">logout</span>
          <span>Log Out</span>
        </button>
      </div>
    </div>
  );
};

export default ProfileDropdown;
